export default __webpack_public_path__ + "static/media/1.04920617.svg";